import Decimal from 'decimal.js'

export const d = (n) => new Decimal(n)
